module.exports = __webpack_public_path__ + "img/45_5.63036d70.png";